import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { UserContextService } from '../../services/user-context.service';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
})
export class CookieConsentComponent implements OnInit {

  visible: boolean = false;

  constructor(
    private cookieService: CookieService,
    private userContextSvc: UserContextService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.userContextSvc.getUserContext().subscribe(ctx => {
      this.visible = !ctx.IsIntranet && !this.findCookie();
      this.cdr.markForCheck();
    });
  }

  findCookie(): boolean {
    return this.cookieService.get('cookie_consent_accepted') === '1';
  }

  declineCookies(): void {
    const now = new Date(Date.now());
    const expires = new Date(now.setMonth(now.getMonth() + 1));

    this.cookieService.set('cookie_consent_accepted', '0', { path: '/', expires: expires });
    this.visible = false;
    // window.open('chrome://settings/cookies', '_blank');
  }

  acceptCookies(): void {
    const now = new Date(Date.now());
    const expires = new Date(now.setMonth(now.getMonth() + 1));

    this.cookieService.set('cookie_consent_accepted', '1', { path: '/', expires: expires });
    this.visible = false;
  }
}
